import { ImageFieldImage, LinkField } from '@prismicio/client';
import { Image } from 'interfaces';
import { prismicToImage } from '../helpers/prismic-to-image';

export class ContentBox {
  public icon: Image;

  constructor(
    public contentBoxIcon: ImageFieldImage,
    public title: string,
    public text: string,
    public buttonText: string,
    public buttonLink: LinkField
  ) {
    if (contentBoxIcon?.url) {
      this.icon = prismicToImage(contentBoxIcon);
    }
  }
}
